import { z } from 'zod'

export const TimezoneSchema = z.object({
  gmt_offset: z.string(),
  timezone: z.string()
})

export type Timezone = z.infer<typeof TimezoneSchema>
